<section class="p-10 bg-ayr-green-1000 py-16">
    <div class="max-w-960 m-auto">
        <app-reviews-slider [commentItems]="ayrComments" />
    </div>
</section>